export const EXPAND_SEARCH = 'EXPAND_SEARCH';
